function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  strokeWidth: 2,
  transform: "translate(1 1)",
  stroke: "#5F1FFB",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20
}), React.createElement("path", {
  strokeLinecap: "square",
  d: "M21.333 25.333L16 20l5.333-5.333"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/back.bfbba122.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/containers/stepView/back.svg
// module id = 520
// module chunks = 0